import { render, staticRenderFns } from "./DepositTab.vue?vue&type=template&id=676c69a9&"
import script from "./DepositTab.vue?vue&type=script&lang=js&"
export * from "./DepositTab.vue?vue&type=script&lang=js&"
import style0 from "./DepositTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports